
export const companyInfo = {
        name: "Mogasoft",
        address: "Bwebajja",
        phone: "0701243139",
        email: "mogasoft3@gmail.com",
        website: "www.mogasoft.com",
        taxId: "4444",
        receiptFooter: "Thank you for your business! Please come again."
    };

export const companyInfo1 = {
        name: "Sharma Electronix",
        address: "Kisenyi",
        phone: "",
        email: "",
        website: "",
        taxId: "",
        receiptFooter: "Thank you for your business! Please come again."
    };






export const developerInfo = {
        name: "mogasoft",
        webSite: "www.mogasoft.com",
        version: "1.0.0"
    };